import { Organization, OrganizationType } from './organization-types';

/**
 * Org types the home view's sidebar selector lists. PLG/DMA-only orgs
 * (DMA_FREEMIUM, DMA_CONSULTANT) and bare COMPANY orgs are excluded — the home
 * view is the investor surface and listing those would just clutter the
 * selector.
 *
 * IMPORTANT: this set does more than declutter the selector. Via
 * `useBuildSelectedOrganization` it also gates which org becomes the
 * `selectedOrganization` that the org-scoped home view (pinned groups +
 * entities) renders against. An org type omitted here resolves to no selected
 * org, so its front-page content renders blank. Do not trim this set purely for
 * "decluttering" reasons without accounting for that side effect. (See
 * PLT-4977: OTHER was missing here, which hid Statista's pinned
 * groups/entities.)
 *
 * The team default organization setting is limited to these types for the same
 * reason: an org the selector does not list can never be opened by default.
 */
const HOME_VIEW_ORG_TYPES: ReadonlySet<OrganizationType> = new Set([
  OrganizationType.AM_AO,
  OrganizationType.PE_VC,
  OrganizationType.ASSET_MANAGER,
  OrganizationType.ASSET_OWNER,
  OrganizationType.INTERNAL,
  OrganizationType.OTHER,
]);

export function isHomeViewOrganization(org: Pick<Organization, 'type'>): boolean {
  return HOME_VIEW_ORG_TYPES.has(org.type);
}
